import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const listDeliveryProfileNames = {
  name: "listDeliveryProfileNames" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(z.object({ id: z.string(), name: z.string() })),
};
